export default __webpack_public_path__ + "static/unity-39804f4265814e1217b9b6205a858dce.png";